import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import db from "../../../../api/mongodb";
import { Container, Row, Col, Image, Form, InputGroup } from "react-bootstrap";
import { defaultOptions1 } from "../../../../config/loading-config.js";
import Lottie from "react-lottie";
import "./SafeAPsGridView.scss";
import SafeAPsGridList from "./SafeAPsGridList";
import SearchIcon from "../../../../images/Search.svg";

const SafeAPsGridView = ({ adminView }) => {
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [safeAPs, setSafeAPs] = useState([]);
  const [activeView, setActiveView] = useState(true);
  const [numActiveSafeAPs, setNumActiveSafeAPs] = useState(0);
  const [numPendingSafeAPs, setNumPendingSafeAPs] = useState(0);
  const [isDisabled, setDisabled] = useState("");
  const [filteredSafeAps, setFilteredSafeAps] = new useState(safeAPs);
  const [selectedTab, setSelectedTab] = useState("approved");

  useEffect(() => {
    apiCall();
  }, [selectedTab]);

  const apiCall = () => {
    db.get(`/api/safeAPs/filter/status/${selectedTab}`, {
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    }).then(
      (response) => {
        setNumActiveSafeAPs(response.data.length);
        setSafeAPs(response.data);
        setFilteredSafeAps(response.data);
      },
      (error) => {}
    );

    setIsLoading(false);

    if (sessionStorage.getItem("name") !== "Admin") {
      setDisabled("disabled-tab");
    }
  };

  const onNavClick = (e, val, status) => {
    db.get(`/api/safeAPs/filter/status/${status}`, {
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    }).then(
      (response) => {
        setNumActiveSafeAPs(response.data.length);
        setSafeAPs(response.data);
        setActiveView(val);
      },
      (error) => {}
    );
  };

  const filterBySearch = (event) => {
    // Access input value
    const query = event.target.value;
    // Create copy of item list
    var updatedList = [...safeAPs];
    // Include all elements which includes the search query
    updatedList = updatedList.filter((item) => {
      return (
        `${item.fullName.first} ${item.fullName.last}`
          .toLowerCase()
          .indexOf(query.toLowerCase()) !== -1
      );
    });
    // Trigger render with updated values
    setFilteredSafeAps(updatedList);
  };

  if (isLoading) {
    return <Lottie options={defaultOptions1} height={200} width={200} />;
  }

  return (
    <>
      <div className="safeAPs-grid">
        <div className="safeAPs-grid-header">
          <h1 className="page-title">SAFE-APs</h1>
        </div>

        <div className="safeAPs-grid-header">
          <div className="search-filter">
            <InputGroup>
              <Form.Label htmlFor="searchSafeAps" hidden>
                Search SAFE-APS
              </Form.Label>
              <InputGroup.Text>
                <img src={SearchIcon} alt="" />
              </InputGroup.Text>
              <Form.Control
                type="text"
                id="input"
                placeholder="Search safe-aps..."
                aria-describedby="searchSafeAps"
                onChange={filterBySearch}
              />
            </InputGroup>
          </div>
        </div>

        <div className="safeAPs-menu-tab">
          <a
            href="#active"
            className={selectedTab === "approved" ? "active" : ""}
            onClick={() => {
              setSelectedTab("approved");
              // filterBySelectedTab("active");
              // setStatus("active");
            }}
          >
            Active
          </a>
          <a
            href="#pending"
            className={selectedTab === "pending" ? "active" : ""}
            onClick={() => {
              setSelectedTab("pending");
              // filterBySelectedTab("active");
              // setStatus("active");
            }}
          >
            Pending
          </a>
          <a
            href="#blocked"
            className={selectedTab === "blocked" ? "active" : ""}
            onClick={() => {
              setSelectedTab("blocked");
              // filterBySelectedTab("active");
              // setStatus("active");
            }}
          >
            Blocked
          </a>
          {/* <span
            onClick={() => {
              setSelectedTab("approved");
              // filterBySelectedTab("active");
              // setStatus("active");
            }}
          >
            <Link
              to="/projects/active"
              // className={projectStatus === "active" ? "active" : ""}
            >
              Active
            </Link>
          </span> */}
          <hr />
        </div>

        <div className="safeAPs-list">
          <Row>
            <SafeAPsGridList
              safeAPs={filteredSafeAps}
              activeView={activeView}
              selectedTab={selectedTab}
            />
          </Row>
        </div>
      </div>
    </>
  );
};

export default SafeAPsGridView;
